import {actionTypes} from 'constants/constants';

const initialState = {
	PIN:'',
};

export default function  (state = initialState, action) {
	switch (action.type) {
		case actionTypes.WS_SETPIN:
			// console.log('setPIN',action.data);
			return Object.assign({},state,action.data);
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/reducers/thefair/worldSmile.js